import { haveFilterQuery, paginator, haveSort } from '../../common/auxFun'

const endpointsSuppliersProposal = {
  CREATE: '/v1/purchases/proposal',
  LOAD: (filter, sort, limit, skip) =>
    `/v1/purchases/proposal${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_ID: (id) => `/v1/purchases/proposal/${id}`,
  BY_ID_AND_PROVINCEID: (id, provinceId) =>
    `/v1/purchases/proposal/${id}/province/${provinceId}`,
  LAST: (province) =>
    `/v1/purchases/proposal/last${province ? '?province='.concat(province) : ''}`,
  UPDATE_SELECTED_PROVINCE_SUPPLIER: (id) =>
    `/v1/purchases/proposal/${id}/selectDefault`,
  UPLOAD: '/v1/purchases/proposal/upload',
}

export default endpointsSuppliersProposal
